import React, { FC, useMemo } from 'react'
import { useController } from 'react-hook-form'
import { Datepicker } from '@wmgtech/legato'
import { localeFormat } from 'shared/utils/formatDate'

import { IProductForm } from '../types'
import { IFieldProps } from './field.props'

import styles from './datafield.module.scss'

export const ReleaseDateField: FC<IFieldProps> = ({ idx }) => {
  const {
    field,
    fieldState: { error }
  } = useController<IProductForm>({
    name: `products.${idx}.publish_date`,
  })

  const selected = useMemo<Date | undefined>(() => {
    const { value } = field
    if (typeof value === 'string' && value.length) return new Date(value)
    return undefined
  }, [field])

  return (
    <Datepicker
      dateFormat={localeFormat()}
      className={styles.date}
      selected={selected}
      placeholder="Select Date"
      onChange={(data: Date) => field.onChange(data.toISOString())}
      validation={{
        message: error?.message,
        ...(error && { type: 'error' })
      }}
    />
  )
}
